export const GOOGLE_PUBLISHER_TAG_DEFAULTS = {
  adUnitPath: '/157593316/supernovacy',
  slotId: 'div-gpt-ad-1781614102748-0',
  sizes: [1, 1] as [number, number],
};
